/* 
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('Recivers', function ($scope, $http) {
	$scope.options = {
		currentPage: 1,
		totalItems: 1,
        perPage: 1,
	};
	
	$scope.showLoader = false;
	$scope.getList = function(){
		$scope.showLoader = true;
		$http.post('/administration/recivers/getlist', $scope.options)
			.success(function(result){
				$scope.groups = result.data;
				$scope.options.totalItems = result.total;
				$scope.options.perPage = result.per_page;
				$scope.showLoader = false;
			});
	};

	$scope._init = function(){
		$scope.getList();
	};
	$scope._init();
});
                  